<template>
    <div ref="loader">

        <!-- Status page name and refresh button -->
        <div class="w-100" v-bind:class="mainHeaderBgClasses">
            <b-container class="container-lg">
                <b-row class="p-0 pt-2">
                    <b-col class="col-9 text-start min-width-0">
                        <h5 class="text-truncate">
                            <i class="fa-solid fa-chevron-left" @click="goBack"></i>
                            {{ statuspage.name }}
                        </h5>
                    </b-col>
                    <b-col class="col-3 text-end">
                        <button type="button" class="btn btn-sm" @click="refreshData"
                                v-bind:class="mainHeaderRefreshBtnClasses">
                            <i class="fa-solid fa-arrows-rotate"
                               :class="{'fa-spin': loading}"></i>
                        </button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-12">
                        {{ statuspage.description }}
                    </b-col>
                </b-row>

                <!-- Status page summary state -->
                <b-row class="p-0 pt-4 pb-4">
                    <b-col class="col-12 text-center">
                        <h3>{{ statuspage.cumulatedHumanStatus }}</h3>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <!-- End of status page header -->

        <!-- List all objects inside of this status page -->
        <b-container class="container-lg pt-4">

            <!-- Start actual list -->
            <b-list-group
                v-for="item in items"
                v-bind:key="item.type + item.id"
                class="mt-2">

                <div class="flex-column align-items-start">
                    <div class="list-group-item flex-column align-items-start list-group-item-action ps-0">
                        <div class="d-flex flex-row min-h-110">
                            <div class="p-2">
                                <div class="h-100 status-line"
                                     v-bind:class="['bg-'+item.cumulatedColor, 'shadow-'+item.cumulatedColor]">
                                </div>
                            </div>
                            <div class="min-width-0">
                                <div class="row p-2">
                                    <div class="col-12 text-truncate h5" v-if="item.type === 'host'">
                                        <router-link :to="{name: 'hostsDetails', params: {id: item.id}}">
                                            {{ item.name }}
                                        </router-link>
                                    </div>
                                    <div class="col-12 text-truncate h5" v-if="item.type === 'service'">
                                        <router-link :to="{name: 'servicesDetails', params: {id: item.id}}">
                                            {{ item.name }}
                                        </router-link>
                                    </div>
                                    <div class="col-12 text-truncate h5" v-if="item.type === 'hostgroup'">
                                        <router-link :to="{name: 'hostgroupsDetails', params: {id: item.id}}">
                                            {{ item.name }}
                                        </router-link>
                                    </div>
                                    <div class="col-12 text-truncate h5" v-if="item.type === 'servicegroup'">
                                        <router-link :to="{name: 'servicegroupsDetails', params: {id: item.id}}">
                                            {{ item.name }}
                                        </router-link>
                                    </div>

                                    <div class="col-12 text-truncate">
                                        <div class="row">
                                            <div class="col-12 text-truncate">
                                                <p :class="[item.cumulatedColor]">{{ item.cumulatedStateName }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 text-truncate">
                                        <div class="row text-small">
                                            <div class="col-12"
                                                 v-if="item.acknowledgedProblemsText && item.cumulatedColorId > 0">
                                                <i class="far fa-user"></i>
                                                {{ item.acknowledgedProblemsText }}
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-12 text-truncate" v-if="item.downtimeData && item.downtimeData.length > 0">
                                        <div class="row text-small">
                                            <div class="col-12">
                                                <i class="fa-solid fa-power-off"></i>
                                                <span>
                                                    {{$t('text.current-statuspage',{count: item.downtimeData.length})}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 text-truncate" v-if="item.plannedDowntimeData && item.plannedDowntimeData.length > 0">
                                        <div class="row text-small">
                                            <div class="col-12">
                                                <i class="fa-solid fa-power-off"></i>
                                                <span>
                                                    {{$t('text.planned-statuspage',{count: item.plannedDowntimeData.length})}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </b-list-group>
            <!-- end new list -->
            <!-- end of actual list -->
        </b-container>
    </div>
</template>
<script>
import Servicestatus from "../utils/Servicestatus.vue";
import DateSwitch from "../utils/DateSwitch.vue";
import {useToast} from "vue-toastification";
import { BContainer } from 'bootstrap-vue-next';

export default {
    name: "StatuspagesDetails",
    components: {BContainer, DateSwitch, Servicestatus},
    data(){
        return {
            loading: true,
            requestStatus: false,
            statuspage: {},
            items: [],
            mainHeaderBgClasses: '',
            mainHeaderRefreshBtnClasses: ''
        }
    },
    async mounted(){
        await this.getData();
    },
    methods: {
        goBack: function(){
            this.$router.back();
        },
        refreshData(){
            this.getData(1);
        },
        getHeaderBgClass(){
            switch(this.statuspage.cumulatedColor){
                case "up":
                case "ok":
                    return 'bg-ok shadow-lg-ok text-white';

                case "warning":
                    return 'bg-warning shadow-lg-warning text-dark';

                case "down":
                case "critical":
                    return 'bg-critical shadow-lg-critical text-white';

                case "unreachable":
                case "unknown":
                    return 'bg-unknown shadow-lg-unknown text-white';

                default:
                    // Not in monitoring
                    return 'bg-primary shadow-lg-primary text-white';
            }
        },
        getHeaderRefreshBtnClass(){
            switch(this.statuspage.cumulatedColor){
                case "up":
                case "ok":
                    return 'btn-success';

                case "warning":
                    return 'btn-warning';

                case "down":
                case "critical":
                    return 'btn-danger';

                case "unreachable":
                case "unknown":
                    return 'btn-secundary text-white';

                default:
                    return 'btn-primary';
            }
        },
        getData: function(){
            let loader = this.$loading.show();
            this.loading = true;
            axios.post('/statuspages/details.json', null, {
                params: {
                    id: this.$route.params.id
                }
            })
                .then(response => {
                    this.requestStatus = true;
                    this.statuspage = response.data.statuspage.statuspage ?? {};
                    this.items = response.data.statuspage.items ?? [];
                    this.mainHeaderBgClasses = this.getHeaderBgClass();
                    this.mainHeaderRefreshBtnClasses = this.getHeaderRefreshBtnClass();
                })
                .catch(error => {
                    console.log(error);
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });

                })
                .finally(() => {
                    loader.hide();
                    this.loading = false;
                });
        }
    }
}
</script>


<style scoped>

.flex-right {
    margin-left: auto;
}

.text-small {
    font-size: 0.875em;
}

</style>
